"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _CountKeys = _interopRequireDefault(require("./example/CountKeys"));

var _KeyboundComponent = require("./KeyboundComponent");

var _keys = require("./keys");

var _default = {
  CountKeys: _CountKeys.default,
  KeyboundComponent: _KeyboundComponent.KeyboundComponent,
  KEYS: _keys.KEYS
};
exports.default = _default;
module.exports = exports.default;